// extracted by mini-css-extract-plugin
export default {"dashboard__grid":"ProviderTransactions_dashboard__grid__0SFg4","spinner__container":"ProviderTransactions_spinner__container__uFIjN"};